import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import CopyRightInfo from "../../../core/common/copyRightInfo";
import ProfilePic from "../../../core/common/profilePic";
import BillingAddress from "../../../core/common/billingAddress";
import useFetch from "../../../hooks/useFetch";
import PreLoader from "../../../core/common/preLoader";
import { API, GENDER } from "../../../common/Constants";
import { getAPIHeaders, getFormattedDateDDMMYYYY, isNotEmpty, isValidEmail, isValidPhoneNumber } from "../../../common/Utils";
import { Profile } from "../../../core/data/interface";

type PasswordField =
  | "oldPassword"
  | "newPassword"
  | "confirmPassword"
  | "currentPassword";

const ProfileForm = () => {
  const { isLoading, error, status, data, callFetch } = useFetch();
  const [passwordVisibility, setPasswordVisibility] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
    currentPassword: false,
  });
  const [userProfile, setUserProfile] = useState<Profile>()
  const [changePassword, setChangePassword] = useState<any>({
    newPassword: "",
    confirmPassword: ""
  })
  const [profileMsg, setProfileMsg] = useState<any>({
    message: '',
    error: false
  })
  const [chnPwdMsg, setChngPwdMsg] = useState<any>({
    message: '',
    error: false
  })
  const [updatePressed, setUpdatePressed] = useState<'PROFILE' | 'PASSWORD' | ''>('')


  useEffect(()=>{
    fetchProfile()
  },[])

  useEffect(() => {
    if(error){
      let errMsg = ""
      if(error.response?.data){
        errMsg = error.response?.data
      } else{
        errMsg = 'Something went wrong please try again later.'
      }
      if(updatePressed === 'PROFILE'){
        setProfileMsg({message: errMsg, error: true})
        setChngPwdMsg({message: "", error: false})
      } else if (updatePressed === 'PASSWORD'){
        setProfileMsg({message: "", error: false})
        setChngPwdMsg({message: errMsg, error: true})
      } else {
        setProfileMsg({message: "", error: false})
        setChngPwdMsg({message: "", error: false})
      }
    }
  }, [error]);

    useEffect(() => {
      if(data && status && status < 299){
        if(updatePressed === 'PASSWORD'){
          setChngPwdMsg({message: "Updated Password Successfully", error: false})
          setProfileMsg({message: "", error: false})
        } else if (updatePressed === 'PROFILE'){
          setProfileMsg({message: "Updated Profile Successfully", error: false})
          setChngPwdMsg({message: "", error: false})
        }
      }
    }, [status]);

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

      
  const fetchProfile = () => {
    callFetch(API.PROFILE,
      'GET',
      getAPIHeaders(),
      null,
      null
    ).then((res)=>{
      setUserProfile(res)
    }).catch((err) => {});
  }

  const handleProfileUpdate = (event:any) => {
    event.preventDefault();
    setUpdatePressed('PROFILE')
    if(!isValidPhoneNumber(userProfile?.phoneNumber)){
      setProfileMsg({message: "Please provide phone number.", error: true})
    } else if (!isValidEmail(userProfile?.email)) {
      setProfileMsg({message: "Please provide email address.", error: true})
    } else {
      callFetch(API.PROFILE,
        'PUT',
        getAPIHeaders(),
        null,
        {
           ...userProfile
        }
      ).then(()=>{
        fetchProfile()
      }).catch((err) => {});
    }
  }

  const handlePasswordUpdate = (event:any) => {
    event.preventDefault();
    setUpdatePressed('PASSWORD')
    if(!isNotEmpty(changePassword?.newPassword)){
      setChngPwdMsg({message: 'Please provide new password.', error: true})
    } else if(!isNotEmpty(changePassword?.confirmPassword)){
      setChngPwdMsg({message:'Please provide confirm password.', error: true})
    } else if(changePassword?.newPassword !== changePassword?.confirmPassword){
      setChngPwdMsg({message:'New password and Confirm password does not match.', error: true})
    } else {
      callFetch(API.PASSWORD,
        'PUT',
        getAPIHeaders(),
        null,
        {
           password: changePassword?.newPassword
        }
      ).then(()=>{
        fetchProfile()
      }).catch((err) => {});
    }
  }

  return (
    <>
      <PreLoader showLoader={isLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Profile </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Pages</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Profile{" "}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="card">
            <div className="card-body">
              <div className="border-bottom mb-3 pb-3">
                <h4>Profile </h4>
              </div>
              <form onSubmit={handleProfileUpdate}>
                <div className="border-bottom mb-3">
                  <div className="row">
                    <div className="col-md-12">
                    <h6 className="mb-3">Basic Information</h6>
                      <ProfilePic id={userProfile?.id}/>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-4">
                          <label className="form-label mb-md-0">First Name</label>
                        </div>
                        <div className="col-md-8">
                          <input type="text" className="form-control" 
                          value={userProfile?.firstName}
                          disabled />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-4">
                          <label className="form-label mb-md-0">Last Name</label>
                        </div>
                        <div className="col-md-8">
                          <input type="text" className="form-control" 
                          value={userProfile?.lastName}
                          disabled />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-4">
                          <label className="form-label mb-md-0">Gender</label>
                        </div>
                        <div className="col-md-8">
                          <input type="text" className="form-control" 
                          value={GENDER.find((e:any) => e.value === userProfile?.gender)?.label}
                          disabled />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-4">
                          <label className="form-label mb-md-0">Date Of Birth</label>
                        </div>
                        <div className="col-md-8">
                          <input type="text" className="form-control" 
                          value={getFormattedDateDDMMYYYY(userProfile?.dob)}
                          disabled />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-4">
                          <label className="form-label mb-md-0">Email</label>
                        </div>
                        <div className="col-md-8">
                          <input type="text" className="form-control"
                          value={userProfile?.email}
                          onChange={(e)=>{
                            setUserProfile({
                              ...userProfile,
                              email: e.target.value
                            })
                          }} />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-4">
                          <label className="form-label mb-md-0">Phone</label>
                        </div>
                        <div className="col-md-8">
                          <input type="text" className="form-control" 
                          value={userProfile?.phoneNumber}
                          onChange={(e)=>{
                            setUserProfile({
                              ...userProfile,
                              phoneNumber: e.target.value? parseInt(e.target.value) : undefined
                            })
                          }}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>                
                {/* <div className="border-bottom mb-3">
                  <h6 className="mb-3">Address Information</h6>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-2">
                          <label className="form-label mb-md-0">Address</label>
                        </div>
                        <div className="col-md-10">
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-4">
                          <label className="form-label mb-md-0">Country</label>
                        </div>
                        <div className="col-md-8">
                          <CommonSelect
                            className="select"
                            options={countryChoose}
                            defaultValue={countryChoose[0]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-4">
                          <label className="form-label mb-md-0">State</label>
                        </div>
                        <div className="col-md-8">
                          <div>
                            <CommonSelect
                              className="select"
                              options={stateChoose}
                              defaultValue={stateChoose[0]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-4">
                          <label className="form-label mb-md-0">City</label>
                        </div>
                        <div className="col-md-8">
                          <div>
                            <CommonSelect
                              className="select"
                              options={cityChoose}
                              defaultValue={cityChoose[0]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-4">
                          <label className="form-label mb-md-0">Postal Code</label>
                        </div>
                        <div className="col-md-8">
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="border-bottom mb-3">
                <div className="flex-column mb-1">

                    {
                    profileMsg.message 
                    ?
                    profileMsg.error
                    ?
                      <div className="text-danger mb-2">
                        <i className="ti ti-alert-triangle" /> {profileMsg?.message} 
                      </div>
                      :
                      <div className="text-success mb-2">
                      <i className="ti ti-thumb-up" /> {profileMsg?.message} 
                    </div>
                    : <></> 
                    } 
                  
                  <div className="mb-3  d-flex align-items-center justify-content-end">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-3"
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Update Profile
                    </button>
                  </div>
                </div>
                </div>
              </form>
              <form onSubmit={handlePasswordUpdate}>
                  <div className="border-bottom mb-3">
                    <h6 className="mb-3">Change Password</h6>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4">
                            <label className="form-label mb-md-0">New Password</label>
                          </div>
                          <div className="col-md-8">
                            <div className="pass-group">
                              <input
                                type={
                                  passwordVisibility.newPassword
                                    ? "text"
                                    : "password"
                                }
                                className="pass-input form-control"
                                value={changePassword?.newPassword}
                                onChange={(e)=>{
                                  setChangePassword(
                                    {
                                      ...changePassword,
                                      newPassword: e.target.value
                                    }
                                  )
                                }}
                              />
                              <span
                                className={`ti toggle-passwords ${passwordVisibility.newPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                                  }`}
                                onClick={() =>
                                  togglePasswordVisibility("newPassword")
                                }
                              ></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4">
                            <label className="form-label mb-md-0">
                              Confirm Password
                            </label>
                          </div>
                          <div className="col-md-8">
                            <div className="pass-group">
                              <input
                                type={
                                  passwordVisibility.confirmPassword
                                    ? "text"
                                    : "password"
                                }
                                className="pass-input form-control"
                                value={changePassword?.confirmPassword}
                                onChange={(e)=>{
                                  setChangePassword(
                                    {
                                      ...changePassword,
                                      confirmPassword: e.target.value
                                    }
                                  )
                                }}
                              />
                              <span
                                className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                                  }`}
                                onClick={() =>
                                  togglePasswordVisibility("confirmPassword")
                                }
                              ></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-column">
                    {
                    chnPwdMsg.message 
                    ?
                    chnPwdMsg.error
                    ?
                      <div className="text-danger mb-2">
                        <i className="ti ti-alert-triangle" /> {chnPwdMsg?.message} 
                      </div>
                      :
                      <div className="text-success mb-2">
                      <i className="ti ti-thumb-up" /> {chnPwdMsg?.message} 
                      </div>
                    : <></> 
                    } 
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-3"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Change Password
                      </button>
                    </div>
                  </div>
              </form>
              
              {/* Billing Address Section */}
              <BillingAddress 
                onAddressSaved={(address) => {
                  console.log('Address saved:', address);
                }}
                showTitle={true}
                className="mt-4"
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <CopyRightInfo/>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>

  );
};

export default ProfileForm;